<template>
  <div>
    <b-card>
      <page-main ref="main" :tree-data="treeData" @submit="reload" />
    </b-card>
  </div>
</template>
<script>
export default {
  name: "master-fabricCategory",
  components: {
    PageMain: () => import("./components/main")
  },
  data() {
    return {
      treeData: []
    };
  },
  methods: {
    // 重载表格数据
    reload() {
      this.handleSubmit();
    },
    // 加载表格数据
    handleSubmit() {
      this.$api
        .masterFabricCategory_tree({})
        .then(res => {
          this.treeData = res.body.data;
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.handleSubmit();
  },
  activated() {
    this.handleSubmit();
  }
};
</script>
